
import CryptoJS from 'crypto-js'; 

export default class AesUtils {

    static AESKEY = 'KVksL2jJ6eLOP7cX';

    static encrypt(enData) {
        return CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(enData),
            CryptoJS.enc.Utf8.parse(AesUtils.AESKEY),
            {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }
        ).toString();
    }

    static decrypt(data) {
        return CryptoJS.AES.decrypt(
            data,
            CryptoJS.enc.Utf8.parse(AesUtils.AESKEY),
            {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }
        ).toString(CryptoJS.enc.Utf8);
    }

    static md5(str) { 
        return CryptoJS.MD5(str).toString();
    }
} 